import { z } from "zod";

export const districtNcesIdSchema = z.string().min(1).brand<"DistrictNcesId">();
export type DistrictNcesId = z.infer<typeof districtNcesIdSchema>;

export const schoolNcesIdSchema = z.string().min(1).brand<"SchoolNcesId">();
export type SchoolNcesId = z.infer<typeof schoolNcesIdSchema>;
